import React from "react";

function BS4_InterviewPrep() {
  return (
    <div>
      <h1>BS4_InterviewPrep Component</h1>
      <p>This is the BS4_InterviewPrep tutorial page content.</p>
    </div>
  );
}

export default BS4_InterviewPrep;
